import { httpCreate } from './http';

const http = httpCreate('/srv/logRecord');

export const logRecord = {
	/** 获取操作日志列表
	 * @param { String } params.operator
	 * @param { String } params.type
	 * @param { Number } params.startTime
	 * @param { Number } params.endTime
	 * @returns
	 */
	getList(params) {
		return http.get('', { params });
	},
};
